import React from 'react';
import { FlameIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTASection() {
  return <section className="py-12 md:py-16 bg-gray-900 text-white" data-id="element-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center" data-id="element-101">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-102">
          ⚡ TU CUERPO NO NECESITA OTRO "EMPIEZO EL LUNES"
        </h2>

        <p className="text-xl md:text-2xl mb-8 text-gray-300" data-id="element-103">
          Necesita un sistema REAL que puedas sostener.
        </p>

        <p className="text-2xl md:text-3xl font-bold mb-12 text-brand-pink-400" data-id="element-104">
          Y eso es exactamente lo que tenés acá.
        </p>

        <div className="mb-8" data-id="element-105">
          <CTAButton size="large" data-id="element-106">EMPEZÁ HOY MISMO</CTAButton>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12" data-id="element-107">
          {['Acceso inmediato', '10 bonos GRATIS', 'Garantía de 7 días', 'Oferta solo 24 horas'].map((item, i) => <div key={i} className="flex items-center justify-center gap-2 bg-brand-pink-600 px-4 py-3 rounded-full" data-id="element-108">
              <FlameIcon className="w-5 h-5" data-id="element-109" />
              <span className="font-bold" data-id="element-110">{item}</span>
            </div>)}
        </div>

        <div className="bg-brand-pink-600 rounded-2xl p-8 mb-8" data-id="element-111">
          <p className="text-xl md:text-2xl font-bold mb-4" data-id="element-112">
            ⚠️ HACÉ CLICK AHORA ANTES DE QUE SUBA EL PRECIO
          </p>
          <CountdownTimer data-id="element-113" />
        </div>
      </div>
    </section>;
}